import { BsTrack, BsUtil, BsTrackExp, BsTrackwaitTime, BsGetCid } from 'dida-web-common'
import DATA from './../config.js'
const common = {
    channelId: BsUtil.queryString('channelId'),
    channelSceneId: BsUtil.queryString('channelSceneId')
}
try {
    const logParams = DATA?.options.basic.logParams || []
    logParams.forEach(key => {
        const rr = key.key.split('=')
        if (rr.length === 2) {
            if (rr[1].indexOf('${') > -1) {
                const value = BsUtil.queryString(rr[1].replace('${', '').replace('}', ''))
                if (value) {
                    common[`${rr[0]}`] = value
                }
            } else {
                common[`${rr[0]}`] = rr[1]
            }
        }
    })
} catch (error) {
    console.log(error)
}

// const pathname = location.pathname.split('/')

// const track = new BsTrack({
//     name: Window.DATA?.desc || pathname.pop() || pathname.pop()
//   }, {
//     ...common
//   }, [
//     BsTrackExp,
//     BsTrackwaitTime
//   ])

// export default track/

export default async(name) => {
    const { cid } = await BsGetCid()
    return new BsTrack({
        name,
        cid
      }, {
        ...common
      }, [
        BsTrackExp,
        BsTrackwaitTime
      ])
}
